module.exports = __webpack_public_path__ + "e0679e028c51f7913a5abfdd2a682f0a.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@deere/cps-it.warranty-base-styles/icons/svg/close-white.svg
// module id = 90
// module chunks = 0